import React from 'react'
import { useTheme } from '../../context/ThemeContext'
import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi'
import './ThemeToggle.css'

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      type='button'
      className='theme-toggle'
      onClick={toggleTheme}
      aria-pressed={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      <span className='theme-toggle__track' aria-hidden='true'>
        <span className='theme-toggle__thumb'>
          {isDark ? <HiOutlineMoon size={16} /> : <HiOutlineSun size={16} />}
        </span>
      </span>
      <span className='theme-toggle__label'>
        {isDark ? 'Dark' : 'Light'}
      </span>
    </button>
  )
}

export default ThemeToggle
